import { TeamMenuSettings, TeamMenuType, UserConfig } from '../types/user';


// get accessible team menu options for the given team menu type
export const getTeamMenuOptions = (
  teamMenuType: TeamMenuType,
  userConfig: UserConfig,
  hasSkillcorner?: boolean
): (keyof TeamMenuSettings)[] => {

  const options: (keyof TeamMenuSettings)[] = [];

  if (teamMenuType === 'teamMenu') {
    options.push(
      'shortNames',
      'country_code',
      'club_logo_url',
      'age',
      'contract_expiration',
      'form_status',
      'availability_status',
      'skill_index',
    );
    if (hasSkillcorner) {
      options.push('physical_index');
    }
    if (userConfig?.accessConfig.hasAccessToScouting || userConfig?.accessConfig.hasAccessToManageRoles) {
      options.push('role_index');
    }
    return options;
  }

  if (teamMenuType === 'ownTeamMenu') {
    options.push('shortNames');
    if (userConfig.accessConfig.hasAccessToViewTeamRoles) {
      options.push('role');
    }
    options.push(
      'country_code',
      'locality',
      'age',
      'contract_expiration',
      'form_status',
      'availability_status',
      'skill_index',
    );
    if (hasSkillcorner) {
      options.push('physical_index');
    }
    if (userConfig?.accessConfig.hasAccessToScouting || userConfig?.accessConfig.hasAccessToManageRoles) {
      options.push('role_index');
    }
    return options;
  }

  if (teamMenuType === 'ownTeamPlannerMenu' && userConfig.accessConfig.hasAccessToPlanner) {
    options.push('shortNames');
    if (userConfig.accessConfig.hasAccessToViewTeamRoles) {
      options.push('role');
    }
    options.push(
      'country_code',
      'locality',
      'age',
      'contract_expiration',
    );
    return options;
  }

  if (teamMenuType === 'academyTeamMenu' && userConfig.accessConfig.hasAccessToAcademy) {
    return [
      'shortNames',
      'academyRole',
      'country_code',
      'birth_date',
      'contract_expiration',
    ];
  }

  return [];
};
